export const IN_VP_EVENT = "zhi-in-vp";
export const OUT_VP_EVENT = "zhi-out-vp";
export const MQ_CHANGE_EVENT = "zhi-mq-change";